import * as React from 'react';
import {useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Stack from "@mui/material/Stack";
import {CircularProgress, InputLabel, Select} from "@mui/material";
import Typography from "@mui/material/Typography";

import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import {useAuth} from "oidc-react";
import {FAILED, LOADING, SUCCESS} from "../../../httpClient";
import {removeUserFromIamGroup} from "../../../features/user-management/user-managementAPI";

export const RemoveUserFromGroupModal = ({ open, setOpen, user, groups, reload }) => {


    const auth = useAuth();
    const [status, setStatus] = useState('');
    const [group, setGroup] = useState('');

    const handleClose = () => {
        setOpen(false);
        setStatus('');
        setGroup('');
    };

    const handleChange = (event) => {
        setGroup(event.target.value);
    };

    const removeUserFromGroup = () => {
        if (group === '') {
            return;
        }

        setStatus(LOADING)

        let body = {
            email: user.email,
            username: user.username,
            group: group
        }

        let token = auth?.userData?.access_token;

        removeUserFromIamGroup(token, JSON.stringify(body))
            .then(resp => {
                if (resp.ok) {
                    setStatus(SUCCESS);
                    reload();
                    return resp;
                }
                throw resp
            })
            .catch(() => {
                setStatus(FAILED);
                setInterval(() => setStatus(''),6000);
            });
    }

    return (
        <div>
            <Dialog open={open} onClose={handleClose} maxWidth={'md'}>
                <DialogTitle>{`Add user to group`}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Remove a user from a group. This removes all access to operate within the context of the selected group.
                    </DialogContentText>

                    <div style={{ marginTop: '1rem'}}/>
                    {
                        status === LOADING ?
                            <Stack alignItems={"center"}>
                                <div style={{ marginTop: '1rem'}}/>
                                <CircularProgress color={"secondary"}/>
                            </Stack>
                            :
                            status === SUCCESS ?
                                <Stack>
                                    <Typography color={'primary'} component={"div"} variant={'h5'} sx={{ mt: '1rem', textAlign: 'center'}}>
                                        {`User: ${user.email} has been added to group`}
                                    </Typography>
                                </Stack>
                                :
                                <>
                                    {
                                        groups && groups.length > 0 ?
                                            <div>
                                                <Stack direction={'row'} spacing={3} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                                                    <Box sx={{ minWidth: 200 }}>
                                                        <FormControl fullWidth>
                                                            <InputLabel id="group-type">Type</InputLabel>
                                                            <Select
                                                                labelId="group-type"
                                                                id="group-type-select"
                                                                value={group}
                                                                label="Group"
                                                                onChange={handleChange}
                                                            >
                                                                {
                                                                    groups.map((type) => <MenuItem key={type.groupName} value={type.groupName}>
                                                                        {type.groupName}
                                                                    </MenuItem>)
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </Box>
                                                </Stack>

                                            </div>
                                            :
                                            null
                                    }
                                </>
                    }

                </DialogContent>

                {
                    status === SUCCESS ?
                        <DialogActions>
                            <Button onClick={handleClose}>Close</Button>
                        </DialogActions>
                        :
                        <DialogActions>
                            <Button onClick={handleClose}>Cancel</Button>
                            <Button onClick={removeUserFromGroup}>remove</Button>
                        </DialogActions>
                }

            </Dialog>
        </div>
    );
}
